import { useEffect, useState, useCallback } from "react";
import { tasksApi } from "@api/tasks";

export function useTasks({ pollMs = 3000 } = {}) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTasks = useCallback(async () => {
    try {
      const data = await tasksApi.list();
      setTasks(data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTasks();
    const t = setInterval(fetchTasks, pollMs);
    return () => clearInterval(t);
  }, [fetchTasks, pollMs]);

  return { tasks, loading, refetch: fetchTasks };
}
